import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { contactLogRepo } from '../repo/contactLogRepo'
import { logAudit } from '@/lib/audit'

export function useCustomerContactLog(customerId: string | undefined) {
  return useQuery({
    queryKey: ['contact-log', customerId],
    queryFn: () => customerId ? contactLogRepo.findByCustomer(customerId) : [],
    enabled: !!customerId,
  })
}

export function useCreateContactLog() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (log: any) => contactLogRepo.create(log),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['contact-log', data.customer_id] })
      logAudit({
        action: 'create_contact',
        resource_type: 'contact_log',
        resource_id: data.id,
        client_id: data.client_id,
      })
    },
  })
}

export function useUpdateContactLog() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, updates }: { id: string; updates: any }) =>
      contactLogRepo.update(id, updates),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['contact-log', data.customer_id] })
      logAudit({
        action: 'update_contact',
        resource_type: 'contact_log',
        resource_id: data.id,
        client_id: data.client_id,
      })
    },
  })
}

export function useDeleteContactLog() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: string) => contactLogRepo.delete(id),
    onSuccess: (_data, id) => {
      queryClient.invalidateQueries({ queryKey: ['contact-log'] })
      logAudit({
        action: 'delete_contact',
        resource_type: 'contact_log',
        resource_id: id,
      })
    },
  })
}
